import _ from '@lodash';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormCheckboxField from 'modules/ui/editform/fields/EditFormCheckboxField';
import EditFormRadioGroupField from 'modules/ui/editform/fields/EditFormRadioGroupField';
import EditFormSubComponent from 'modules/ui/editform/subForm/EditFormSubComponent';
import DashboardRoleEditService from '../service/DashboardRoleEditService';

const config = {
	key: 'dashboardRoleEditForm',
	topic: 'user',
	service: DashboardRoleEditService,
	watchTitleKey: 'title',
	tabList: [
		{
			key: 'basic'
		},
		{
			key: 'servicePermissionList'
		},
		{
			key: 'contentPermissionList'
		}
	],
	fields: [
		{
			key: 'title',
			tab: 'basic',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'key',
			tab: 'basic',
			component: EditFormTextField
		},
		{
			key: 'adminDescription',
			tab: 'basic',
			component: EditFormTextField,
			multiline: true
		},
		{
			key: 'orderIndex',
			tab: 'basic',
			type: 'number',
			component: EditFormTextField
		},
		{
			key: 'isSuperAdmin',
			tab: 'basic',
			component: EditFormCheckboxField
		},
		{
			key: 'isEnabled',
			tab: 'basic',
			component: EditFormCheckboxField
		},
		{
			key: 'servicePermissionList',
			tab: 'servicePermissionList',
			component: EditFormSubComponent,
			defaultValue: {
				id: null,
				key: null,
				name: null,
				title: null,
				service: null,
				grantedLevel: null
			},
			fields: [
				{
					key: 'service',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					items: () => DashboardRoleEditService.getServicePermissionListServiceSelection()
				},
				{
					key: 'grantedLevel',
					component: EditFormRadioGroupField,
					required: true,
					type: 'enum',
					items: [
						{
							label: 'Csak olvasható',
							value: 'ReadOnly'
						},
						{
							label: 'Írás-olvasás',
							value: 'WriteRead'
						},
						{
							label: 'Hozzáférés megtagadva',
							value: 'Deny'
						}
					]
				}
			]
		},
		{
			key: 'contentPermissionList',
			tab: 'contentPermissionList',
			component: EditFormSubComponent,
			watchTitleKey: 'title',
			defaultValue: {
				id: null,
				key: null,
				name: null,
				title: null,
				contentType: null,
				grantedLevel: null
			},
			fields: [
				{
					key: 'contentType',
					component: EditFormSelectField,
					required: true,
					items: () => DashboardRoleEditService.getContentPermissionListContentTypeSelection()
				},
				{
					key: 'grantedLevel',
					component: EditFormRadioGroupField,
					required: true,
					type: 'enum',
					items: [
						{
							label: 'Csak olvasható',
							value: 'ReadOnly'
						},
						{
							label: 'Írás-olvasás',
							value: 'WriteRead'
						},
						{
							label: 'Hozzáférés megtagadva',
							value: 'Deny'
						}
					]
				}
			]
		}
	]
};

function DashboardRoleEditForm() {
	return <EditFormPage config={config} />;
}

export default DashboardRoleEditForm;
